/**
 * Generates a unique identifier safe for non-critical uses.
 *
 * Uses `crypto.randomUUID()` when available (modern browsers and Node.js 19+).
 * Falls back to a timestamp-based identifier in environments without crypto support.
 *
 * @returns A UUID string when crypto.randomUUID is available, otherwise a
 *          timestamp-based unique string in the format `{timestamp}-{random}-{random}-{random}`
 *
 * @example
 * // Use for session tracking, analytics correlation IDs, or other non-security-critical purposes
 * const submissionId = safeNonCriticalRandomUUID()
 *
 * @note The fallback is NOT cryptographically secure and should NOT be used for:
 * - Authentication tokens
 * - Security-sensitive identifiers
 * - Anything requiring true randomness
 */
export function safeNonCriticalRandomUUID() {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}-${Math.random().toString(36).slice(2, 10)}-${Math.random().toString(36).slice(2, 6)}`
}
